import MicroModal from 'micromodal';  // es6 module


MicroModal.init();
// Listen for clicks on links that point to a modal ID
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href').substring(1); // Get 'modal-1'
      
      console.log(targetId);
      // Check if an element with that ID exists
      if (document.getElementById(targetId)) {
        e.preventDefault();
        MicroModal.show(targetId); // Manually trigger MicroModal
      }
    });
  });